import { truncateLength } from "@/components/app-layout/consts";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { UserAvatar } from "./UserAvatar";

type UserDisplayNameProps = {
  user: {
    name: string | null;
    email?: string | null;
    photo_url?: string | null;
  };
  className?: string;
  variant?: "default" | "large";
};

export const UserDisplayName: React.FC<UserDisplayNameProps> = ({
  user,
  className,
  variant = "default",
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        { "flex-col": variant === "large" },
        className,
      )}
    >
      <UserAvatar user={user} size={variant === "large" ? "lg" : "sm"} />
      {(() => {
        const text = user.name || user.email || "Unknown User";
        if (text.length <= truncateLength) return <span>{text}</span>;
        return (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span>{`${text.slice(0, truncateLength)}…`}</span>
              </TooltipTrigger>
              <TooltipContent>{text}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      })()}
    </div>
  );
};

type UserOrUnknownDisplayNameProps = Pick<
  UserDisplayNameProps,
  "className" | "variant"
> & {
  user: UserDisplayNameProps["user"] | null;
};

export const UserOrUnknownDisplayName: React.FC<
  UserOrUnknownDisplayNameProps
> = ({ user, ...rest }) => {
  if (!user) {
    return (
      <UserDisplayName
        {...rest}
        user={{ name: "Unknown User", email: undefined, photo_url: undefined }}
      />
    );
  }
  return <UserDisplayName {...rest} user={user} />;
};
